<template>
  <div class="main-body">
    <div class="header">排班</div>
    <div class="out">

      <div class="search2">

        <el-button type="info" size="mini" @click.native="handleInfo">排班信息</el-button>

        <div style="float:right;font-size: 12px;">

          <el-select v-model="institutionCode" placeholder="请选择机构" style="margin-right:10px">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-date-picker size="mini"
                          ref="picker"
                          v-model="datetimerangeValue"
                          type="daterange"
                          :clearable='false'
                          value-format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          style="width:230px;margin-right:10px">
          </el-date-picker>
          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>

        </div>

        <div style="clear: both;"></div>
      </div>

      <div :style="styleTh">
        <el-calendar v-model="calendarDate" :range='range'>
          <template slot="dateCell" slot-scope="{date, data}">
            <p :class="isSelecteds(date) ? 'is-selected' : ''">
              {{ data.day.split('-').slice(1).join('-') }}
              <!--              {{ isSelecteds(date) ? '✔️' : ''}}-->
            </p>

            <el-popover v-if="getDayInfo(date)"
                        placement="top-start" width="150" trigger="hover">
              <el-button slot="reference" size="small" type="text">已排班</el-button>

              <div v-if="getDayInfo(date).type==2">
                <div>
                  <div>白班</div>
                  <span v-for="item in getDayInfo(date).nursingSchedulingDaytime.nursingSchedulingDaytimeItemList" :key="item.nursingSchedulingDaytimeItemCode">
                      <span v-show="item.nurseName">护士：{{item.nurseName}}<br></span>
                      <span v-show="item.nurseAideName">护工：{{item.nurseAideName}}<br></span>
                  </span>
                </div>
                <div>
                  <div>夜班</div>
                  <span v-for="item in getDayInfo(date).nursingSchedulingNighttime.nursingSchedulingNighttimeItemList" :key="item.nursingSchedulingNighttimeItemCode">
                      <span v-show="item.nurseName">护士：{{item.nurseName}}<br></span>
                      <span v-show="item.nurseAideName">护工：{{item.nurseAideName}}<br></span>
                  </span>
                </div>
              </div>
              <div v-if="getDayInfo(date).type==3">
                <div>
                  <div>早班</div>
                  <span v-for="item in getDayInfo(date).nursingSchedulingMorning.nursingSchedulingMorningItemList" :key="item.dishesCode">
                      <span v-show="item.nurseName">护士：{{item.nurseName}}<br></span>
                      <span v-show="item.nurseAideName">护工：{{item.nurseAideName}}<br></span>
                  </span>
                </div>
                <div>
                  <div>中班</div>
                  <span v-for="item in getDayInfo(date).nursingSchedulingNoon.nursingSchedulingNoonItemList" :key="item.dishesCode">
                      <span v-show="item.nurseName">护士：{{item.nurseName}}<br></span>
                      <span v-show="item.nurseAideName">护工：{{item.nurseAideName}}<br></span>
                  </span>
                </div>
                <div>
                  <div>晚班</div>
                  <span v-for="item in getDayInfo(date).nursingSchedulingNight.nursingSchedulingNightItemList" :key="item.dishesCode">
                      <span v-show="item.nurseName">护士：{{item.nurseName}}<br></span>
                      <span v-show="item.nurseAideName">护工：{{item.nurseAideName}}<br></span>
                  </span>
                </div>
              </div>

            </el-popover>

          </template>
        </el-calendar>
      </div>

    </div>

    <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="closeInfo" v-bind:dataList="tableData"></Info>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Info from "../Ins/Info";

export default {
  name: "Role",
  data(){
    return{
      loading:false,

      showModalInfo:false,


      tableData:[],

      dateList:[],

      datetimerangeValue:'',
      calendarDate:'',
      range:[],

      th:0,
      styleTh:{
        height:'',
        background:'#fff',
        'overflow-y':'auto'
      },

      arr_ins:[],
      institutionCode: '',

    }
  },
  components:{
    Info,
  },
  created(){
    this.init();

    this.th = this.$store.state.tableHeight;
    this.styleTh.height=this.$store.state.tableHeight+50+'px';
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
      this.styleTh.height=val+50+'px';
    },
    calendarDate(val){
      this.getDate(val)
    }
  },
  methods:{
    init(){
      const start= new Date();
      const end=new Date(start.getTime() + 1000 * 60 * 60 * 24 * 15);
      this.datetimerangeValue=[start, end];
      this.getWeekDate(this.datetimerangeValue)

      this.getIns();

    },

    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:1,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },


    handleInfo(){
      this.showModalInfo=true
      this.$refs.myInfo.init();
    },
    closeInfo:function(){
      this.showModalInfo = !this.showModalInfo;
    },


    getWeekDate(date){
      var startDate=new Date(date[0])
      startDate.setDate(startDate.getDate() - startDate.getDay() + 1);
      var endDate=new Date(date[1])
      endDate.setDate(endDate.getDate() - endDate.getDay() + 7);
      this.range=[timefilters(startDate).slice(0,10),timefilters(endDate).slice(0,10)]
    },
    timefilter(row, column, cellValue){
      return timefilters(cellValue)
    },
    isSelecteds(date){
      var list=this.dateList
      var getDate=timefilters(date).slice(0,10)
      if(list.indexOf(getDate)>-1){
        return true
      }
      return false
    },
    getDayInfo(data){
      var list=this.tableData
      var row=''
      list.forEach(element => {
        if(timefilters(element.time).slice(0,10)==timefilters(data).slice(0,10)){
          row=element
        }
      });
      return row
    },
    getDate(date){
      var newDate=timefilters(new Date()).slice(0,10)
      var getDate=timefilters(date).slice(0,10)
      if(new Date(newDate)<=new Date(date)){
        var list=this.dateList
        if(list.indexOf(getDate)>-1){
          list.splice(list.indexOf(getDate), 1)
        }else{
          list.push(getDate)
        }
        this.dateList=list
      }else{
        //this.$message.error('只能编辑今天以及今天以后的排班')
      }
    },


    getList(){
      this.loading = true;
      this.getWeekDate(this.datetimerangeValue)

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"NursingScheduling/GovPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
          startTime:this.range[0],
          endTime:this.range[1],
        }
      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          //this.totalItems = response.data.data.total;
          this.dateList=[]
        }
      }).catch(function (error) {
        console.log(error);
      });
    },



  }
}
</script>
<style lang="scss" scoped>

</style>
